import { reportsInitialState } from './reports'

export const localInitialState = {
  ...reportsInitialState,
}
